<script setup lang="ts">
  import { ColoredButton, IconImage } from '@/shared/ui';
  import AddButtonInline from '@/shared/assets/icons/AddButtonInline.svg';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';
  import DeleteButton from '@/shared/assets/icons/DeleteButton.svg';

  const props = defineProps<{
    notificationDates: Date[];
  }>();

  const formatDisplayDate = (date: Date | null) => {
    if (!date) return 'Selecione uma data';
    return date.toLocaleDateString('pt-BR');
  };

  const emit = defineEmits<{
    (e: 'update:notification-dates', value: Date[]): void;
    (e: 'open-date-picker'): void;
  }>();

  const addNotificationDate = () => {
    emit('open-date-picker');
  };

  const removeNotificationDate = (index: number) => {
    const newDates = [...props.notificationDates];
    newDates.splice(index, 1);
    emit('update:notification-dates', newDates);
  };
</script>

<template>
  <div class="flex flex-row items-center justify-between pr-6">
    <div class="flex flex-col items-center justify-between p-6">
      <div class="flex flex-col gap-3">
        <label class="text-sm font-semibold text-gray-07">Selecione as datas de notificação:</label>
        <div
          v-for="(date, index) in notificationDates"
          :key="date.toISOString()"
          class="flex items-center gap-2"
        >
          <div
            class="flex items-center gap-2 w-fit px-4 py-2 border border-gray-02 rounded-lg text-gray-07 bg-white-01"
          >
            <IconImage
              :src="CalendarIcon"
              alt="Calendar"
            />
            <span class="text-left text-sm">{{ formatDisplayDate(new Date(date)) }}</span>
          </div>
          <IconImage
            :src="DeleteButton"
            alt="Remover"
            class="cursor-pointer text-[var(--theme-secondary-ink)]"
            @click="removeNotificationDate(index)"
          />
        </div>
      </div>
    </div>
    <ColoredButton
      v-if="notificationDates.length < 3"
      :icon="AddButtonInline"
      text="Adicionar datas"
      @click="addNotificationDate"
    />
  </div>
</template>
